// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_VYI","cls2":"AuthorHeader-cls2_LMJ AuthorHeader-cls1_VYI"};